<template>
  <v-list class="py-0 cross-row">
    <v-list-item-group v-model="doctor">
      <template v-for="(docter, index) in docterItem">
        <v-divider :key="`${index}-divider`"></v-divider>
        <v-list-item :key="index" v-ripple>
          <v-list-item-content>
            <v-list-item-title class="body-2">{{
              docter.name
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
    </v-list-item-group>
  </v-list>
</template>
<style scoped>
.cross-row .v-list-item:nth-child(4n) {
  background: #fafbfc;
}
</style>
<script>
export default {
  props: ["clinic", "value"],
  data: () => ({
    docterItem: [],
    doctor: ""
  }),
  watch: {
    doctor(val) {
      this.$emit(
        "input",
        val !== undefined ? this.docterItem[val].name : undefined
      );
    }
  },
  methods: {
    async getDoctors() {
      let response = await this.$ajax.post(
        `${this.$config.apiUrl}/${this.clinic}/search/user`,
        { permission: "role_admin" }
      );
      let thisVm = this;
      response.data.forEach(doctor => {
        thisVm.docterItem.push({ name: doctor.name, _id: doctor._id });
      });
      response = await this.$ajax.post(
        `${this.$config.apiUrl}/${this.clinic}/search/user`,
        { permission: "role_staff" }
      );
      response.data.forEach(doctor => {
        thisVm.docterItem.push({ name: doctor.name, _id: doctor._id });
      });
    }
  },
  mounted() {
    this.getDoctors();
  }
};
</script>
